"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/fanclub/v1/internal_common.proto (package spwn.fanclub.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalPlan = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.fanclub.v1.InternalPlan
 */
class InternalPlan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * planのfirestore id
         *
         * @generated from field: string plan_firestore_id = 1;
         */
        this.planFirestoreId = "";
        /**
         * planの名前
         *
         * @generated from field: string plan_name = 2;
         */
        this.planName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalPlan, a, b);
    }
}
exports.InternalPlan = InternalPlan;
InternalPlan.runtime = protobuf_1.proto3;
InternalPlan.typeName = "spwn.fanclub.v1.InternalPlan";
InternalPlan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "plan_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=internal_common_pb.js.map